var B = Object.defineProperty, R = Object.defineProperties;
var _ = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
var d = (e, o, s) => o in e ? B(e, o, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[o] = s, i = (e, o) => {
  for (var s in o || (o = {}))
    c.call(o, s) && d(e, s, o[s]);
  if (t)
    for (var s of t(o))
      p.call(o, s) && d(e, s, o[s]);
  return e;
}, l = (e, o) => R(e, _(o));
var v = (e, o) => {
  var s = {};
  for (var r in e)
    c.call(e, r) && o.indexOf(r) < 0 && (s[r] = e[r]);
  if (e != null && t)
    for (var r of t(e))
      o.indexOf(r) < 0 && p.call(e, r) && (s[r] = e[r]);
  return s;
};
import { jsx as b } from "react/jsx-runtime";
import "react";
import { c as w } from "./get-size-BzhHC8s2.js";
import { c as C } from "./create-vars-resolver-Bzbn9G-G.js";
import { j as T, b as V, B as f, f as k } from "./factory-BnRIVbT0.js";
import { u as q } from "./use-styles-CB9_o8RJ.js";
var y = { root: "m_3eebeb36", label: "m_9e365f20" };
const A = {
  orientation: "horizontal"
}, E = C((e, { color: o, variant: s, size: r }) => ({
  root: {
    "--divider-color": o ? k(o, e) : void 0,
    "--divider-border-style": s,
    "--divider-size": w(r, "divider-size")
  }
})), h = T((e, o) => {
  const s = V("Divider", A, e), n = s, {
    classNames: r,
    className: u,
    style: D,
    styles: z,
    unstyled: g,
    vars: x,
    color: F,
    orientation: N,
    label: a,
    labelPosition: P,
    mod: S
  } = n, j = v(n, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "color",
    "orientation",
    "label",
    "labelPosition",
    "mod"
  ]), m = q({
    name: "Divider",
    classes: y,
    props: s,
    className: u,
    style: D,
    classNames: r,
    styles: z,
    unstyled: g,
    vars: x,
    varsResolver: E
  });
  return /* @__PURE__ */ b(
    f,
    l(i(i({
      ref: o,
      mod: [{ orientation: N, "with-label": !!a }, S]
    }, m("root")), j), {
      role: "separator",
      children: a && /* @__PURE__ */ b(f, l(i({ component: "span", mod: { position: P } }, m("label")), { children: a }))
    })
  );
});
h.classes = y;
h.displayName = "@mantine/core/Divider";
export {
  h as D
};
